<div fxLayout="column" fxFill [ngStyle]="{ 'min-height': '60px' }">
  @if (this.uiconfig.renderHeader) {
    <abc-toolbar class="arena-toolbar" [ngStyle]="{ direction: rtlEnabled ? 'rtl' : 'ltr' }">
      <ng-container content>
        <div class="arena-name-container" [ngStyle]="{ direction: rtlEnabled ? 'rtl' : 'ltr' }">
          <button mat-mdc-button class="arena-icon">
            <mat-icon svgIcon="{{ this.uiconfig.applicationIcon }}"></mat-icon>
          </button>
          <span class="arena-title">{{ this.uiconfig.applicationTitle }}</span>
        </div>
        <button fxLayout="row" class="profile-button" mat-mdc-button [matMenuTriggerFor]="menu">
          <div style="display: flex" fxLayout="row" *abcLet="arenaUserObservable$ | async as arenaUser">
            @if (arenaUser?.imgPortrait) {
              <img class="loginImg" src="data:image/png;base64,{{ arenaUser?.imgPortrait }}" />
            }
            @if (!arenaUser?.imgPortrait) {
              <mat-icon class="loginImg" svgIcon="user"></mat-icon>
            }
            <div fxLayout="row">
              <span fxFlex="100" style="margin-right: 5px; margin-top: 10px">{{
                canLogout ? arenaUser?.displayText : ''
              }}</span>
            </div>
          </div>
        </button>
      </ng-container>
    </abc-toolbar>
  }

  <mat-menu [ngClass]="rtlEnabled ? 'profile-menu-items-rtl' : 'profile-menu-items'" #menu="matMenu">
    @if (areProfilesSupported && (profileInfoObservable$ | async); as profileInfo) {
      <button
        id="selectProfileButton"
        mat-menu-item
        [ngClass]="rtlEnabled ? 'menu-item-rtl' : 'menu-item'"
        attr.aria-label="{{ arenaService.res('Arena-SelectUserProfile') }}"
        (click)="selectProfile()"
      >
        <mat-icon svgIcon="select_profile"></mat-icon>
        <!-- {{ res('Arena-Profile') }} -->
        {{ currentProfileDisplayText }}
      </button>
    }
    @if (allowSettings) {
      <button mat-menu-item [ngClass]="rtlEnabled ? 'menu-item-rtl' : 'menu-item'" (click)="openSettings()">
        <mat-icon svgIcon="settings"></mat-icon>
        {{ arenaService.res('Arena-Settings') }}
      </button>
    }
    <button
      mat-menu-item
      [ngClass]="rtlEnabled ? 'menu-item-rtl' : 'menu-item'"
      [matMenuTriggerFor]="leftMenu"
      matMenuTriggerRestoreFocus="false"
    >
      <mat-icon svgIcon="arena"></mat-icon>
      {{ arenaService.res('Arena-Profiles') }}
    </button>

    @if (this.uiconfig.helpUrl?.length > 0) {
      <button mat-menu-item [ngClass]="rtlEnabled ? 'menu-item-rtl' : 'menu-item'" (click)="openHelp()">
        <mat-icon svgIcon="help"></mat-icon>
        {{ arenaService.res('Arena-Help') }}
      </button>
    }
    @if (canLogout) {
      <button mat-menu-item [ngClass]="rtlEnabled ? 'menu-item-rtl' : 'menu-item'" (click)="logout()">
        <mat-icon svgIcon="logout"></mat-icon>
        {{ arenaService.res('Arena-Logout') }}
      </button>
    }
  </mat-menu>

  <mat-menu #leftMenu="matMenu" xPosition="before">
    <button mat-menu-item (click)="openArenaProfilePopup(false)">
      <mat-icon svgIcon="arena-Profil"></mat-icon>
      {{ arenaService.res('Arena-Load-Arena-Profile') }}
    </button>

    <button mat-menu-item (click)="openArenaProfilePopup(true)">
      <mat-icon svgIcon="konfiguration-speichern"></mat-icon>
      {{ arenaService.res('Arena-Save-Current-Arena-Profile') }}
    </button>
    <div class="menu-divider"></div>
    <button mat-menu-item (click)="resetDefaultSettings()">
      <mat-icon svgIcon="reset"></mat-icon>
      {{ arenaService.res('Arena-Reset-Default-Settings') }}
    </button>
  </mat-menu>

  @if (this.uiconfig.renderDrawer) {
    <abc-drawer
      #abcDrawer
      [openedStateMode]="'shrink'"
      [position]="rtlEnabled ? 'left' : 'right'"
      [revealMode]="'slide'"
      [opened]="false"
      [height]="this.uiconfig.renderHeader ? 'calc(100% - var(--top-bar-height))' : '100%'"
    >
      @if (this.uiconfig.renderHigon) {
        <arena-higon
          #higonComponent
          content="abcDrawerContainer"
          [rtlEnabled]="rtlEnabled"
          style="padding-top: 5px; height: 250px; width: 250px"
        ></arena-higon>
      }
      <abc-side-nav
        #sideNav
        id="sideNav"
        [openedStorageKey]="isStandaloneDataForm ? undefined : 'arena-nav-open'"
        content="abcDrawerContent"
        [showHeader]="this.uiconfig.renderNavigation"
        [rtlEnabled]="rtlEnabled"
        (resizeEvent)="onResize($event)"
        (itemCollapsedEvent)="onResize($event)"
        (itemExpandedEvent)="onResize($event)"
      >
        <div #sideNavItemsContainer class="navigation-item-container">
          @for (menu of nvGroup; track menu; let i = $index) {
            <div>
              @if (menu.data.VisibleIndex > -1 && menu.data.IsVisible) {
                <div
                  class="navigation-item"
                  [class.active-nav-item]="menu === currentNavigationGroup"
                  content="header"
                  id="{{ menu.name }}"
                  (click)="openNavigationGroup(menu, undefined, true)"
                  [matBadge]="menu.badgeValue"
                  [matBadgeHidden]="menu.badgeValue === 0"
                  matBadgeColor="warn"
                  matBadgeSize="small"
                >
                  <img
                    [matTooltipPosition]="'right'"
                    [matTooltipClass]="'navigation-tooltip'"
                    matTooltip="{{ menu.caption }}"
                    src="{{ menu.data.ImageUrl }}"
                    class="sideNavIcon"
                  />
                </div>
              }
            </div>
          }
          @if (nestedNvGroup.length) {
            <div
              class="navigation-item"
              [matBadge]="sumBadgeValues(nestedNvGroup)"
              [matBadgeHidden]="sumBadgeValues(nestedNvGroup) === 0"
              matBadgeColor="warn"
              matBadgeSize="small"
            >
              <abc-drop-down-button
                [items]="nestedNvGroup"
                [displayExpr]="'caption'"
                [keyExpr]="'name'"
                [height]="'var(--side-bar-width)'"
                [rtlEnabled]="rtlEnabled"
                [class.active-nav-item]="nestedNvGroup.includes(currentNavigationGroup)"
                [icon]="'more'"
                [showArrowIcon]="false"
                [dropDownOptions]="{
                  width: 180,
                  wrapperAttr: { class: 'navigation-nested-items-container' },
                }"
                [itemTemplate]="'nav-item'"
                (onItemClick)="openNestedNavigationGroup($event)"
              >
                <div
                  class="nested-nav-item"
                  [class.active-nav-item]="item === currentNavigationGroup"
                  *dxTemplate="let item of 'nav-item'"
                  [matBadge]="item.badgeValue"
                  [matBadgeHidden]="item.badgeValue === 0"
                  matBadgeColor="warn"
                  matBadgeSize="small"
                >
                  <img src="{{ item.data.ImageUrl }}" />
                  <p>
                    {{ item.caption }}
                  </p>
                </div>
              </abc-drop-down-button>
            </div>
          }
        </div>
        <div id="drawerContainer" fxLayout="column" content="drawerContainer" class="drawerContainer">
          @if (!this.uiconfig.isStandaloneDataForm) {
            @if (layoutPath && !arenaService.externalComponent && showLoader) {
              <abcLoader [show]="showLoader" id="arenaLoader" [class]="'arenaLoader'"></abcLoader>
            }
            @if (layoutPath && !arenaService.externalComponent && this.uiconfig.renderMenu) {
              <arena-menu #menuComponent [isStandaloneDataForm]="this.uiconfig.isStandaloneDataForm"></arena-menu>
            }
            @if (!showLoader && layoutPath && !arenaService.externalComponent && this.uiconfig.renderHigon) {
              <div
                [ngClass]="rtlEnabled ? 't1ArenaRtl t2ArenaRtl' : 't1 t2'"
                id="returnIcon"
                (click)="toggleHigonDrawer()"
              >
                <mat-icon class="return">keyboard_arrow_left</mat-icon>
              </div>
            }
            @if (tileNavs?.length) {
              <div fxFlex="none" fxLayout="row" fxLayoutAlign="start end">
                <abc-tile-nav
                  class="arena-tile-nav"
                  [dataSource]="tileNavs"
                  (OnTileClick)="navigateToTileNav($event)"
                  [displayExpr]="'caption'"
                  [offset]="40"
                  [rtlEnabled]="rtlEnabled"
                ></abc-tile-nav>
              </div>
            }
            @if (
              layoutPath && !arenaService.externalComponent && this.uiconfig.renderDataForm && this.uiconfig.renderHigna
            ) {
              <div
                fxFlex="100"
                [ngClass]="{
                  'drawer-container-horizontalLayout': this.uiconfig.layoutSplitterOrientation === 'horizontal',
                }"
              >
                <abc-spl
                  #layoutSplitterComponent
                  id="layoutSplitterComponent"
                  [orientation]="this.uiconfig.layoutSplitterOrientation"
                  (onResize)="dividerPanMove($event)"
                  (onItemCollapsed)="collapseDataForm($event)"
                  (onItemExpanded)="expandDataForm($event)"
                >
                  @if (this.uiconfig.layoutSplitterOrientation === 'horizontal') {
                    <dxi-item size="40%" [collapsible]="true" class="splitterHignaItemHorizontal">
                      <arena-higna #hignaComponent id="hignaComponent"></arena-higna>
                    </dxi-item>
                    <dxi-item size="60%" [minSize]="'200'" [collapsible]="true">
                      <arena-data-form #dataFormComponent id="dataFormComponent"></arena-data-form>
                    </dxi-item>
                  } @else {
                    <dxi-item size="70%" [minSize]="'200'" [collapsible]="true" class="splitterDFItem">
                      <arena-data-form #dataFormComponent id="dataFormComponent"></arena-data-form>
                    </dxi-item>
                    <dxi-item size="30%" [collapsible]="true" class="splitterHignaItemVertical">
                      <arena-higna #hignaComponent id="hignaComponent"></arena-higna>
                    </dxi-item>
                  }
                </abc-spl>
              </div>
            }
            @if (
              layoutPath &&
              !arenaService.externalComponent &&
              this.uiconfig.renderDataForm &&
              !this.uiconfig.renderHigna
            ) {
              <arena-data-form #dataFormComponent id="dataFormComponent" [style.height]="'100%'"></arena-data-form>
            }
            @if (
              layoutPath &&
              !arenaService.externalComponent &&
              !this.uiconfig.renderDataForm &&
              this.uiconfig.renderHigna
            ) {
              <arena-higna #hignaComponent id="hignaComponent" [style.height]="'100%'"></arena-higna>
            }
          }
        </div>
        <div content="drawerContent">
          @if (this.uiconfig.renderNavigation) {
            <arena-navigation
              #navigationComponent
              id="navigationComponent"
              [rtlEnabled]="rtlEnabled"
              [dir]="rtlEnabled ? 'rtl' : 'auto'"
            ></arena-navigation>
          }
        </div>
      </abc-side-nav>
    </abc-drawer>
  }

  @if (this.uiconfig.isStandaloneDataForm) {
    <div id="standaloneDataForm">
      @if (layoutPath && (!this.layoutViewModel?.isReadOnly || context.layoutUsage === 'New')) {
        <arena-menu #menuComponent [isStandaloneDataForm]="this.uiconfig.isStandaloneDataForm"></arena-menu>
      }
      <arena-data-form #dataFormComponent id="dataFormComponent" class="arena-data-form-standalone"></arena-data-form>
    </div>
  }
  <abc-popup
    #arenaProfilesPopup
    [visible]="false"
    [title]="
      isSavingArenaProfile
        ? arenaService.res('Arena-Save-Current-Arena-Profile')
        : arenaService.res('Arena-Load-Arena-Profile')
    "
    [position]="'center'"
    [deferRendering]="'false'"
    [width]="'30%'"
    [height]="'auto'"
    fxLayout="column"
    fxLayoutGap="5px"
  >
    <div
      style="height: 100%; padding: 20px !important"
      fxLayout="column"
      fxLayoutAlign="space-evenly"
      fxLayoutGap="20px"
      class="arena-profile-form"
    >
      <abc-select-box
        class="profiles-select-box"
        [(value)]="selectedArenaProfile"
        [width]="'100%'"
        [dataSource]="arenaProfiles"
        [showClearButton]="true"
        [acceptCustomValue]="isSavingArenaProfile"
        [searchEnabled]="true"
        placeholder=""
        [label]="isSavingArenaProfile ? arenaService.res('SelectOrEnterProfile') : arenaService.res('Profile')"
        [dropDownOptions]="{
          wrapperAttr: { class: 'profiles-select-box-popup' },
        }"
      >
      </abc-select-box>
      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
        <abc-button
          text="{{ arenaService.res('Menu-Save') }}"
          class="submitButton"
          [disabled]="selectedArenaProfile ? false : true"
          (onClick)="syncArenaProfile()"
        ></abc-button>
        <abc-button
          text="{{ arenaService.res('Menu-Cancel') }}"
          class="closeButton"
          (onClick)="closeArenaProfilesPopup()"
        ></abc-button>
      </div>
    </div>
  </abc-popup>
</div>
